import { EstadoCaso, OrigenCaso } from '../../../api/altasCasosApi';

/**
 * Definición visual de los 6 estados del caso (spec §2).
 * COPIADO CON REVISIÓN del mockup T05 (`lib/estado.ts`, FUENTE_HISTORICA — único fichero de
 * lógica autorizado a heredarse junto a FilaComparada y el patrón de pestañas): en la revisión
 * se re-clavea de literales string a los IDs numéricos reales del catálogo
 * `FC_C_ALTA_CASO_ESTADO` del backend. Colores y etiquetas se conservan tal cual
 * (ajuste 1 validado por María: "En espera" gold ≠ "Pendiente" naranja; "Alta directa" purple
 * porque nace ya cerrada; "Registro eliminado" se etiqueta **"Descartada"**).
 */
export const ESTADO_LABELS: Record<EstadoCaso, string> = {
  [EstadoCaso.Pendiente]: 'Pendiente',
  [EstadoCaso.EnEspera]: 'En espera',
  [EstadoCaso.RegistroValidado]: 'Registro validado',
  [EstadoCaso.ClienteExistenteActualizado]: 'Cliente existente actualizado',
  [EstadoCaso.RegistroEliminado]: 'Descartada',
  [EstadoCaso.AltaDirecta]: 'Alta directa',
};

export const ESTADO_COLORS: Record<EstadoCaso, string> = {
  [EstadoCaso.Pendiente]: 'orange',
  [EstadoCaso.EnEspera]: 'gold',
  [EstadoCaso.RegistroValidado]: 'green',
  [EstadoCaso.ClienteExistenteActualizado]: 'blue',
  [EstadoCaso.RegistroEliminado]: 'default',
  [EstadoCaso.AltaDirecta]: 'purple',
};

export const ORIGEN_LABELS: Record<OrigenCaso, string> = {
  [OrigenCaso.Web]: 'Web',
  [OrigenCaso.Manual]: 'Manual',
  [OrigenCaso.Asesor]: 'Asesor',
};

export const ORIGEN_COLORS: Record<OrigenCaso, string> = {
  [OrigenCaso.Web]: 'blue',
  [OrigenCaso.Manual]: 'geekblue',
  [OrigenCaso.Asesor]: 'cyan',
};

/** Ref legible del caso a partir del ID (D-GC-05 §1.2: no hay columna propia). */
export const formatearRef = (idCaso: number): string => `AC-${String(idCaso).padStart(6, '0')}`;
